import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

const Contact: React.FC = () => {
  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <h2>Contact Us</h2>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography>
          For help, please contact AFT Membership using one of the options below.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography>
          Phone: <a href="tel:+18002381133,3421"> 1-800-238-1133 EXT. 3421</a>
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography>
          Email:{' '}
          <a href="mailto:AFTConvention@aft.org" target="_top">
            AFTConvention@aft.org
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Contact;
